import React from 'react'
import TimeSeriesWithBands from './renderer/timeSeriesWithBands'
import TimeSeriesComparison from './renderer/timeSeriesComparison'
import TimeSeriesComparisonBars from './renderer/timeSeriesComparisonBars'
import ButtonsPanel from './renderer/buttonPanel'
import { AnyVisualization, ButtonsPanelButton } from './visualization.types'
import type { Alert } from '~/packages/variable/variables.typing'

interface VisualizationProps {
  visualization: AnyVisualization
  isExpanded: boolean
  isMaximized?: boolean
  activeButton?: string
  onButtonClick?: (button: ButtonsPanelButton) => void
  activeLabel?: string
  alert?: Alert | null
  insightTitle?: string
  animated?: boolean
  animationDelay?: number
}

export default function Visualization({
  visualization,
  isExpanded,
  isMaximized,
  activeButton,
  onButtonClick,
  activeLabel,
  alert,
  insightTitle,
  animated = false,
  animationDelay = 0,
}: VisualizationProps) {
  return (
    <div>
      {visualization.renderer === 'timeSeriesWithBands' && (
        <TimeSeriesWithBands
          visualization={visualization}
          isExpanded={isExpanded}
          isMaximized={isMaximized}
          alert={alert}
        />
      )}
      {visualization.renderer === 'timeSeriesComparison' && (
        <TimeSeriesComparison
          visualization={visualization}
          isExpanded={isExpanded}
          isMaximized={isMaximized}
          activeButton={activeButton}
          activeLabel={activeLabel}
          insightTitle={insightTitle}
        />
      )}
      {visualization.renderer === 'timeSeriesComparisonBars' && (
        <TimeSeriesComparisonBars
          visualization={visualization}
          isExpanded={isExpanded}
          isMaximized={isMaximized}
          activeButton={activeButton}
          activeLabel={activeLabel}
          insightTitle={insightTitle}
          animated={animated}
          animationDelay={animationDelay}
        />
      )}
      {visualization.renderer === 'buttons' && (
        <ButtonsPanel
          visualization={visualization}
          isExpanded={isExpanded}
          isMaximized={isMaximized}
          onButtonClick={onButtonClick}
        />
      )}
      {visualization.renderer === 'unknown' && <div>Unknown visualization renderer</div>}
    </div>
  )
}
